import { authenticatedApiFetch } from "../../common/helpers";

export const getLoanAndAgreementDetails = async (params) => {
  return await authenticatedApiFetch(
    "loan/details",
    "GET",
    params
  ).then((result) => {
    return {
      ...result.data,
    };
  });
};

export const getAdditionalAgreement = async ({ application_id, ...queryParams }) => {
  return await authenticatedApiFetch(
    "agreement",
    "GET",
    queryParams,
    {},
    "v1",
    { skipNotFoundRedirect: true }
  ).then((result) => {
    if (!result || !result.data) {
      throw new Error('Additional agreement is not available');
    }
    return {
      ...result.data,
    };
  });
};